export default __webpack_public_path__ + "static/media/leftArrow.934e0f0f.svg";